module.exports = __webpack_public_path__ + "img/-LV4uTk00IoFM29PaKVB.2e048ec8.jpg";